module.exports = __webpack_public_path__ + "fonts/darwin-black-webfont.509cb03.eot";